export const comments_3389322 = {"data":{"data":[],"links":{}}}